

export const popupNewsletter = () => {

	let popupNewsletterForm = document.querySelector('#newsletter-signup-form'),
		popupNewsletterFormComplete = document.querySelector('#js__newsletter-thankyou');;

	if(popupNewsletterForm){
		popupNewsletterForm.addEventListener("submit", (event) => {
			event.preventDefault();

			let formData = new FormData(popupNewsletterForm);
			let isFormValid = true;

			console.log(formData);
			
			//Pass through the recaptcha token
			//formData.append('recaptcha',token);

			 if (isFormValid) {
			    fetch(igniteAjax.ajaxurl, {
			        method: 'POST',
			        body: formData,
			    })
				.then((response) => response.text())
				.then((data) => {
					console.log(data);
					popupNewsletterForm.classList.add('hidden');
					popupNewsletterFormComplete.classList.remove('hidden');
				})
				.catch((error) => {
					console.log(error);
					alert('An error occured, please try again');
				});
			 }

		});

	}
}